import { h } from 'preact'
import CoreScroll from '@nrk/core-scroll'
import { BaseElement } from '@nrk/dh-server-libs/base-element'

// INFO: Since preact isn't loaded in client,
// we have to import images here, so webpack will find them
import './app.module.css'
import './static/eiffel-big.png'
import './static/logo-text.png'
import './static/paralympics.png'
import './static/ol-ringer.png'
import './static/ol-ringer-small.png'
import './static/ol2024-logo.png'
import './static/paralympics2024-logo.png'
import './static/para-composite.png'
import './static/para-composite-big.png'
import './static/no-flag.png'
import './static/medal.png'

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

class AppElement extends BaseElement {
  name = 'dh-sportsbanner-v2'

  render() {
    this.initCoreScroll()
  }

  findClosestProgramEntry(container: HTMLElement): HTMLElement {
    // no scroll container
    if (container == null) {
      return
    }

    const today = container.querySelector<HTMLElement>('[data-today]')
    // events haven't started or last event was yesterday
    if (today == null) {
      return
    }

    const events = today.querySelectorAll<HTMLDivElement>('[data-timestamp]')
    if (events.length === 0) {
      return today
    }

    const now = new Date()
    const closestEvent = Array.from(events)
      .reverse()
      .find((el) => now > new Date(el.dataset.timestamp))

    return closestEvent ?? today
  }

  async initCoreScroll() {
    const scrollElement: HTMLElement = this.querySelector('.dh-sportsbanner-scroll')
    let scrollTarget: HTMLElement
    const ongoingElements = scrollElement.querySelectorAll<HTMLElement>(
      '.dh-sportsbanner-dh-sports-banner__program-event-ongoing'
    )
    if (!ongoingElements.length) {
      scrollTarget = this.findClosestProgramEntry(scrollElement)
    } else {
      scrollTarget = ongoingElements[0]
    }

    if (scrollTarget) {
      if (document.fonts?.ready) {
        await document.fonts.ready
      }

      // core-scroll overrides Element.scroll(), so we bypass that
      Element.prototype.scroll.call(scrollElement, {
        left: scrollTarget.offsetLeft,
        behavior: 'auto',
      } as ScrollToOptions)
    }
  }
}

safeDefine('dh-sportsbanner-core-scroll', CoreScroll)
safeDefine('dh-sportsbanner-v2', AppElement)
